import type en from '../en/sites'
import type { Translation } from '../types'

/** Sites */
const sites: Translation<typeof en> = {
  "sites.deleted": "Standort gelöscht",
  "sites.deleteFailed": "Der Standort konnte nicht gelöscht werden",
  "sites.syncTriggered": "Synchronisierung gestartet",
  "sites.syncFailed": "Synchronisierung fehlgeschlagen",
  "sites.managed": { one: "{count} verwalteter Standort", other: "{count} verwaltete Standorte" },
  "sites.addSite": "Standort hinzufügen",
  "sites.site": "Standort",
  "sites.location": "Ort",
  "sites.lastSync": "Letzte Synchronisierung",
  "sites.none": "Noch keine Standorte – fügen Sie Ihren ersten UniFi-Standort hinzu",
  "sites.notInLicence": "Nicht in Ihrer Lizenz",
  "sites.configureDevice": "Gerät konfigurieren",
  "sites.syncNow": "Jetzt synchronisieren",
  "sites.confirmDelete": "Standort „{name}“ löschen?",
  "sites.add.title": "UniFi-Standort hinzufügen",
  "sites.add.name": "Name des Standorts *",
  "sites.add.namePlaceholder": "Hauptsitz",
  "sites.add.locationPlaceholder": "Berlin, Deutschland",
  "sites.add.descriptionPlaceholder": "Optionale Beschreibung",
  "sites.add.apiKey": "UniFi-API-Schlüssel *",
  "sites.add.apiKeyPlaceholder": "API-Schlüssel aus der UniFi Network Application",
  "sites.add.signInWith": "Anmelden mit",
  "sites.add.signInKey": "API-Schlüssel (UniFi-OS-Konsole)",
  "sites.add.signInLogin": "Benutzername und Passwort (selbst gehosteter Network Server)",
  "sites.add.username": "Benutzername *",
  "sites.add.password": "Passwort *",
  "sites.add.loginHint": "Ein selbst gehosteter Network Server hat keine API-Schlüssel: Verwenden Sie dort ein lokales Konto ohne Bestätigung in zwei Schritten. Das Passwort wird verschlüsselt gespeichert und nie angezeigt.",
  "sites.add.controllerUrl": "Controller-URL",
  "sites.add.hintConsole": "UniFi-OS-Konsole (Dream Machine, Cloud Gateway, Cloud Key):",
  "sites.add.hintSelfHosted": "Selbst gehosteter Network Server:",
  "sites.add.hintSiteManager": "Für Konsolen, die Sie über unifi.ui.com erreichen, verwenden Sie „+ Site Manager“.",
  "sites.add.siteId": "Site-ID",
  "sites.add.note": "Hinweis:",
  "sites.add.noteText": "Nach dem Hinzufügen wird automatisch ein VPN-Konto eingerichtet. Der Standort wird aktiv, sobald er sich über VPN verbindet.",
  "sites.synced": "Synchronisiert",
  "sites.notFound": "Standort nicht gefunden",
  "sites.back": "Zurück zu den Standorten",
  "sites.firmwareAvailable": "⬆ Firmware verfügbar",
  "sites.lastSyncWhen": "Letzte Synchronisierung {when}",
  "sites.never": "nie",
  "sites.sync": "Synchronisieren",
  "sites.tab.overview": "Übersicht",
  "sites.tab.topology": "Topologie",
  "sites.tab.devices": "Geräte ({count})",
  "sites.tab.vlans": "VLANs ({count})",
  "sites.tab.wifi": "WLAN ({count})",
  "sites.tab.clients": "Clients ({count})",
  "sites.tab.traffic": "Datenverkehr",
  "sites.tab.alerts": "Warnungen",
  "sites.tab.alertsCount": "Warnungen ({count})",
  "sites.connectedNow": "jetzt verbunden",
  "sites.connectionsUp": "Verbindungen aktiv",
  "sites.download": "Download",
  "sites.upload": "Upload",
  "sites.uploadRate": "{rate} Upload",
  "sites.experienceScore": "Erlebnisbewertung",
  "sites.wifiGood": "✓ Gutes WLAN-Erlebnis",
  "sites.wifiFair": "⚠ Mittelmäßiges WLAN-Erlebnis",
  "sites.wifiPoor": "✕ Schlechtes WLAN-Erlebnis",
  "sites.averageAcross": { one: "Durchschnitt über {count} WLAN-Client", other: "Durchschnitt über {count} WLAN-Clients" },
  "sites.wanConnections": "WAN-Verbindungen",
  "sites.loadBalanced": "Lastverteilung",
  "sites.noWan": "Noch keine WAN-Daten",
  "sites.throughput": "Durchsatz",
  "sites.noHistory": "Noch kein Verlauf",
  "sites.noTopology": "Keine Topologiedaten – synchronisieren Sie zuerst den Standort",
  "sites.networkTopology": "Netzwerktopologie",
  "sites.connectionsCount": { one: "{count} Verbindung", other: "{count} Verbindungen" },
  "sites.legend.wired": "— Kabelverbindung",
  "sites.legend.wireless": "– – Funkverbindung (Mesh)",
  "sites.legend.ap": "📶 Access Point",
  "sites.legend.switch": "🔀 Switch",
  "sites.legend.gateway": "🔒 Gateway",
  "sites.legend.clientCount": "🔵 = Anzahl Clients",
  "sites.legend.update": "⬆ = Update verfügbar",
  "sites.model": "Modell",
  "sites.type": "Typ",
  "sites.experience": "Erlebnis",
  "sites.firmwareUpdate": "⬆ Firmware-Update verfügbar",
  "sites.radios": "Funkmodule",
  "sites.channel": "Kanal {channel}",
  "sites.utilization": "Auslastung: {percent} %",
  "sites.noDevices": "Keine Geräte",
  "sites.update": "⬆ Update",
  "sites.uptime": "LAUFZEIT",
  "sites.clientsCaps": "CLIENTS",
  "sites.radioTable": "Funktabelle",
  "sites.channelUtilization": "Kanalauslastung",
  "sites.portTable": "Porttabelle",
  "sites.port": "Port",
  "sites.portN": "Port {n}",
  "sites.speed": "Geschwindigkeit",
  "sites.down": "Inaktiv",
  "sites.upBadge": "AKTIV",
  "sites.downBadge": "INAKTIV",
  "sites.uptimeDays": "{d} T. {h} Std.",
  "sites.uptimeHours": "{h} Std. {m} Min.",
  "sites.vlanId": "VLAN-ID",
  "sites.purpose": "Zweck",
  "sites.subnet": "Subnetz",
  "sites.noVlans": "Keine VLANs",
  "sites.noWifi": "Keine WLAN-Netzwerke",
  "sites.guest": "GAST",
  "sites.clientsLower": "Clients",
  "sites.busiest": "Am stärksten ausgelastet: {ap} ({count})",
  "sites.client": "Client",
  "sites.connection": "Verbindung",
  "sites.noClients": "Keine Clients",
  "sites.conn.wired": "kabelgebunden",
  "sites.conn.wireless": "drahtlos",
  "sites.dpi.0": "Sonstiges",
  "sites.dpi.1": "Instant Messaging",
  "sites.dpi.2": "P2P",
  "sites.dpi.3": "Dateiübertragung",
  "sites.dpi.4": "Streaming",
  "sites.dpi.5": "E-Mail",
  "sites.dpi.6": "VoIP",
  "sites.dpi.7": "Gaming",
  "sites.dpi.8": "Soziale Medien",
  "sites.dpi.9": "Werbung",
  "sites.dpi.10": "Web",
  "sites.dpi.11": "Sicherheit",
  "sites.dpi.other": "Kat. {n}",
  "sites.noDpi": "Keine DPI-Daten – erfordert UniFi mit aktivierter DPI",
  "sites.trafficByCategory": "Datenverkehr nach Kategorie",
  "sites.breakdown": "Aufschlüsselung",
  "sites.noActiveAlerts": "Keine aktiven Warnungen",
  "sites.config.field.enableDisable": "Verbindung aktiviert",
  "sites.config.help.enableDisable": "Uplink ein- oder ausschalten",
  "sites.config.field.priority": "Priorität",
  "sites.config.help.priority": "Die niedrigere Zahl gewinnt, wenn mehrere Verbindungen aktiv sind",
  "sites.config.field.failover": "Failover",
  "sites.config.help.failover": "Bei Ausfall auf eine Ersatzverbindung umschalten",
  "sites.config.field.loadBalance": "Lastverteilung",
  "sites.config.help.loadBalance": "Sitzungen auf aktive Verbindungen verteilen",
  "sites.config.field.weights": "Lastgewicht",
  "sites.config.help.weights": "Anteil des Datenverkehrs für diese Verbindung",
  "sites.config.field.healthCheck": "Zustandsprüfung",
  "sites.config.help.healthCheck": "Verbindung prüfen und bei Fehler als ausgefallen markieren",
  "sites.config.field.smartQueue": "Smart Queue (QoS)",
  "sites.config.help.smartQueue": "Bufferbloat unter Last verringern",
  "sites.config.field.staticIp": "Statische IP",
  "sites.config.help.staticIp": "Für DHCP leer lassen",
  "sites.config.field.mtu": "MTU",
  "sites.config.help.mtu": "Meist 1500, bei PPPoE 1492",
  "sites.config.field.simSwitch": "Aktiver SIM-Steckplatz",
  "sites.config.help.simSwitch": "Beim Wechsel wird die Verbindung kurz unterbrochen",
  "sites.config.field.apn": "APN",
  "sites.config.help.apn": "Name des Zugangspunkts des Anbieters",
  "sites.config.field.dataLimit": "Monatliches Datenlimit",
  "sites.config.help.dataLimit": "Warnungen werden bei 90 % davon ausgelöst",
  "sites.config.field.roaming": "Roaming erlauben",
  "sites.config.help.roaming": "Teuer außerhalb des Heimnetzes",
  "sites.config.field.bandLock": "Bandsperre",
  "sites.config.help.bandLock": "Bänder durch Kommas getrennt, leer = automatisch",
  "sites.config.field.pin": "SIM-PIN",
  "sites.config.field.ssid": "SSID",
  "sites.config.field.security": "Sicherheit",
  "sites.config.field.band": "Band",
  "sites.config.field.guest": "Gastnetzwerk",
  "sites.config.help.guest": "Trennt Clients vom LAN",
  "sites.config.field.vlanTag": "VLAN-Tag",
  "sites.config.field.schedule": "Zeitplan aktiviert",
  "sites.config.field.txPower": "Sendeleistung",
  "sites.config.field.fastRoaming": "Schnelles Roaming (802.11r)",
  "sites.config.field.mode": "Rolle",
  "sites.config.field.frequency": "Frequenz",
  "sites.config.help.frequency": "60-GHz-Funkmodule: 58320, 60480, 62640, 64800 oder 66000",
  "sites.config.field.channelWidth": "Kanalbreite",
  "sites.config.help.channelWidth": "Bei 60 GHz nicht verwendet",
  "sites.config.field.protocol": "Protokoll",
  "sites.config.help.protocol": "Nur 2,4/5-GHz-Treiber „wireless“",
  "sites.config.field.linkKey": "Verbindungsschlüssel",
  "sites.config.help.linkKey": "Mindestens 8 Zeichen; muss an beiden Enden übereinstimmen. Wird nach dem Speichern nie angezeigt",
  "sites.config.field.linkTxPower": "Sendeleistung",
  "sites.config.help.linkTxPower": "Bleiben Sie innerhalb des Grenzwerts Ihrer Regulierungsdomäne",
  "sites.config.field.linkSsid": "Verbindungsname (SSID)",
  "sites.config.help.linkSsid": "Muss an beiden Enden übereinstimmen",
  "sites.config.field.vlan": "VLAN",
  "sites.config.field.dhcp": "DHCP-Server",
  "sites.config.field.firewall": "Firewall",
  "sites.config.field.portForward": "Portweiterleitung",
  "sites.config.field.staticRoutes": "Statische Routen",
  "sites.config.field.dns": "DNS-Server",
  "sites.config.help.dns": "Durch Kommas getrennt",
  "sites.config.field.speedfusion": "SpeedFusion",
  "sites.config.field.reconnect": "Tunnel neu verbinden",
  "sites.config.help.reconnect": "Trennt die Bündelung und baut sie neu auf",
  "sites.config.field.createProfile": "Neues Profil",
  "sites.config.field.vpnClient": "VPN-Client",
  "sites.config.field.reboot": "Gerät neu starten",
  "sites.config.help.reboot": "Das Gerät ist 1–2 Minuten offline",
  "sites.config.field.firmwareCheck": "Nach Firmware suchen",
  "sites.config.field.firmwareUpgrade": "Firmware installieren",
  "sites.config.help.firmwareUpgrade": "Installiert die neueste verfügbare Version",
  "sites.config.field.backup": "Konfiguration sichern",
  "sites.config.field.restore": "Konfiguration wiederherstellen",
  "sites.config.field.ntp": "NTP-Server",
  "sites.config.field.timezone": "Zeitzone",
  "sites.config.field.hostname": "Hostname",
  "sites.config.field.adminPassword": "Administratorpasswort",
  "sites.config.section.wan": "WAN",
  "sites.config.blurb.wan": "Uplink-Verhalten, Failover und Lastverteilung",
  "sites.config.section.cellular": "Mobilfunk",
  "sites.config.blurb.cellular": "SIM, APN, Datenlimits und Roaming",
  "sites.config.section.wifi": "WLAN",
  "sites.config.blurb.wifi": "SSIDs, Sicherheit und Funkeinstellungen",
  "sites.config.section.link": "Richtfunkstrecke",
  "sites.config.blurb.link": "Einstellungen für Punkt-zu-Punkt- und Punkt-zu-Mehrpunkt-Verbindungen. Ändern Sie zuerst jede Station und danach innerhalb von 10 Minuten den Access Point; die Frequenz wird nur am Access Point eingestellt.",
  "sites.config.section.network": "Netzwerk",
  "sites.config.blurb.network": "VLANs, DHCP, Firewall und Routing",
  "sites.config.section.tunnel": "Tunnel",
  "sites.config.blurb.tunnel": "SpeedFusion- und VPN-Client-Profile",
  "sites.config.section.system": "System",
  "sites.config.blurb.system": "Neustart, Firmware, Zeit und Identität",
  "sites.config.option.ap-ptp": "Access Point – Punkt-zu-Punkt",
  "sites.config.option.ap-ptmp": "Access Point – Punkt-zu-Mehrpunkt",
  "sites.config.option.station": "Station (Gegenstelle / CPE)",
  "sites.config.option.open": "offen",
  "sites.config.option.both": "beide",
  "sites.config.option.auto": "automatisch",
  "sites.config.option.low": "niedrig",
  "sites.config.option.medium": "mittel",
  "sites.config.option.high": "hoch",
  "sites.config.option.any": "beliebig",
  "sites.config.applied": { one: "{count} Änderung übernommen", other: "{count} Änderungen übernommen" },
  "sites.config.someFailed": "Einige Änderungen sind fehlgeschlagen",
  "sites.config.unsupportedHere": "Auf diesem Gerät nicht unterstützt",
  "sites.config.title": "{name} konfigurieren",
  "sites.config.subtitle": "Es werden nur Optionen angezeigt, die dieses Gerät unterstützt",
  "sites.config.hide": "Ausblenden",
  "sites.config.history": "Verlauf",
  "sites.config.apply": "{count} übernehmen",
  "sites.config.missing": "Fehlende Konfiguration: {items} – verbinden Sie diesen Standort neu, um die Konfiguration zu ermöglichen.",
  "sites.config.readOnly": "{label} ist über dieses Dashboard schreibgeschützt. Die Überwachung funktioniert weiterhin normal.",
  "sites.config.readFailed": "Die aktuellen Einstellungen konnten nicht vom Gerät gelesen werden",
  "sites.config.readFailedNote": "Die Felder unten sind leer, weil sie unbekannt sind, nicht weil sie ausgeschaltet sind.",
  "sites.config.available": "Auf diesem Gerät verfügbar",
  "sites.config.appliesTo": "Gilt für",
  "sites.config.notSupportedBy": "Nicht unterstützt von {label}",
  "sites.config.raw": "Roher Gerätezustand",
  "sites.config.changed": "geändert",
  "sites.config.notReported": "Aktueller Zustand vom Gerät nicht gemeldet",
  "sites.config.unknownState": "Aktueller Zustand unbekannt",
  "sites.config.discard": "Diese Änderung verwerfen",
  "sites.config.historyTitle": "Verlauf der Konfigurationsänderungen",
  "sites.config.noChanges": "Noch keine Änderungen erfasst",
  "sites.config.when": "Wann",
  "sites.config.section": "Bereich",
  "sites.config.field": "Feld",
  "sites.config.value": "Wert",
  "sites.search": "Standorte suchen",
  "sites.searchPlaceholder": "Nach Name suchen…",
  "sites.brand": "Marke",
  "sites.allBrands": "Alle Marken",
  "sites.noneMatch": "Keine passenden Standorte",
  "sites.matching": { one: "{count} passender Standort", other: "{count} passende Standorte" },
  "sites.config.offline.copy": "Dieses Gerät ist offline — Einstellungen wie gelesen {when}. Änderungen werden gespeichert und gesendet, sobald es zurück ist.",
  "sites.config.offline.none": "Dieses Gerät wurde noch nicht erreicht — Änderungen werden gespeichert und beim ersten Kontakt gesendet.",
  "sites.config.offline.save": "Für später speichern ({count})",
  "sites.config.offline.saved": { one: "{count} Änderung für die Rückkehr des Geräts gespeichert", other: "{count} Änderungen für die Rückkehr des Geräts gespeichert" },
  "sites.config.offline.pendingValue": "wartet: {value} · {by} · {when}",
  "sites.pending.title": "Wartende Änderungen",
  "sites.pending.waitingUnit": "Gesendet, sobald das Gerät zurück ist",
  "sites.pending.conflict": "Am Gerät geändert auf {unit} — Ihre: {mine}",
  "sites.pending.keepMine": "Meine behalten",
  "sites.pending.keepUnit": "Die des Geräts behalten",
  "sites.pending.waitingFor": "Wartet, bis {names} zuerst seine eigene Link-Änderung hat",
  "sites.pending.release": "Trotzdem senden",
  "sites.pending.failed": "Fehlgeschlagen: {error}",
  "sites.pending.discard": "Verwerfen",
  "sites.pending.decision": "Entscheidung nötig",
  "sites.pending.count": { one: "{count} wartet", other: "{count} warten" },
  "sites.config.offline.noneSeen": "Dieses Gerät antwortet gerade nicht, und seine Einstellungen wurden noch nicht gelesen — Änderungen werden gespeichert und beim nächsten Kontakt gesendet.",
  "sites.cloud.status.OK": "Funktioniert",
  "sites.cloud.status.WAITING_VPN": "Wartet auf sein VPN",
  "sites.cloud.status.FAILED": "Fehlgeschlagen",
  "sites.cloud.reach.PUBLIC": "Unter einer Adresse",
  "sites.cloud.reach.VIA_SITE_VPN": "Über das VPN eines Standorts",
  "sites.cloud.reach.OWN_VPN": "Die eigene VPN-Verbindung des Controllers",
  "sites.cloud.reachHint.PUBLIC": "Der Controller antwortet unter einer öffentlichen Adresse mit einem gültigen Zertifikat.",
  "sites.cloud.reachHint.VIA_SITE_VPN": "Ein Gerät an einem Ihrer Standorte mit VPN-Verbindung leitet den Port des Controllers weiter — kein Cloud-Abo, kein offener Port.",
  "sites.cloud.reachHint.OWN_VPN": "Der Rechner des Controllers verbindet sich selbst mit dem VPN der Plattform (OpenVPN unter Windows oder Linux).",
  "sites.cloud.reachHint.needsVpn": "Erfordert die Berechtigung, VPN-Verbindungen zu verwalten.",
  "sites.cloud.connectionName": "Name",
  "sites.cloud.connectionNamePlaceholder": "z. B. Controller Zentrale",
  "sites.cloud.reachLabel": "Wie das Dashboard den Controller erreicht",
  "sites.cloud.address": "Adresse des Controllers",
  "sites.cloud.addressHint": "Ein gültiges Zertifikat ist nötig: unter einer öffentlichen Adresse beweist nichts anderes, wer antwortet.",
  "sites.cloud.noVpnSites": "Noch keiner Ihrer Standorte hat eine VPN-Verbindung. Fügen Sie zuerst einen hinzu (ein MikroTik, ein UniFi-Gateway oder ein anderer VPN-Client vor Ort).",
  "sites.cloud.viaSite": "Standort",
  "sites.cloud.chooseSite": "Standort wählen",
  "sites.cloud.port": "Port des Controllers",
  "sites.cloud.forwardIntro": "Leiten Sie auf dem Gerät bei {site} den Port {port} seiner VPN-Adresse {ip} an die LAN-Adresse des Controllers weiter.",
  "sites.cloud.lanAddress": "LAN-Adresse des Controllers",
  "sites.cloud.forwardMikrotik": "Auf einem MikroTik, im Terminal:",
  "sites.cloud.lanPlaceholder": "<LAN-Adresse des Controllers>",
  "sites.cloud.credentials": "Omada-Zugangsdaten",
  "sites.cloud.credentialsWhere": "Öffnen Sie im Omada-Controller {menu}, fügen Sie eine Anwendung im Modus Client hinzu und kopieren Sie Client ID und Client Secret. Die Omada ID steht auf derselben Seite.",
  "sites.cloud.omadacId": "Omada ID",
  "sites.cloud.clientId": "Client ID",
  "sites.cloud.clientSecret": "Client Secret",
  "sites.cloud.keptPlaceholder": "Gesetzt — leer lassen zum Behalten",
  "sites.cloud.registerTitle": "Omada-Standorte hinzufügen",
  "sites.cloud.registerSubtitle": "Die Standorte eines TP-Link-Omada-Controllers, erreicht über Ihr VPN oder unter einer Adresse",
  "sites.cloud.savedWaiting": "Gespeichert — wartet auf die VPN-Verbindung des Controllers",
  "sites.cloud.connected": "Mit dem Controller verbunden",
  "sites.cloud.connectFailed": "Verbindung fehlgeschlagen",
  "sites.cloud.otherConnection": "Andere Verbindung",
  "sites.cloud.failed": "Letzter Fehler: {reason}",
  "sites.cloud.editInSettings": "Verbindung bearbeiten",
  "sites.cloud.useConnection": "Eine Verbindung verwenden",
  "sites.cloud.newConnection": "Eine neue Verbindung",
  "sites.cloud.connect": "Verbinden",
  "sites.cloud.downloadFailed": "Download fehlgeschlagen",
  "sites.cloud.waitingTitle": "Wartet auf die VPN-Verbindung des Controllers",
  "sites.cloud.waitingText": "Laden Sie diese VPN-Verbindung herunter und starten Sie sie auf dem Rechner des Controllers. Sobald der Tunnel steht, werden die Zugangsdaten geprüft und die Standorte des Controllers erscheinen hier — diese Seite prüft alle 10 Sekunden.",
  "sites.cloud.downloadOvpn": ".ovpn herunterladen",
  "sites.cloud.ovpnWindows": "Windows: OpenVPN installieren, die Datei importieren und verbinden; den OpenVPN-Dienst automatisch starten lassen, damit der Tunnel nach einem Neustart zurückkommt.",
  "sites.cloud.ovpnLinux": "Linux: die Datei nach /etc/openvpn/client/velanox.conf kopieren und systemctl enable --now openvpn-client@velanox ausführen.",
  "sites.cloud.added": { one: "{count} Standort hinzugefügt", other: "{count} Standorte hinzugefügt" },
  "sites.cloud.addFailed": "Standorte konnten nicht hinzugefügt werden",
  "sites.cloud.sitesFailed": "Die Standorte des Controllers konnten nicht gelesen werden: {reason}",
  "sites.cloud.controllerSites": "Standorte des Controllers",
  "sites.cloud.noControllerSites": "Der Controller hat keine Standorte.",
  "sites.cloud.deviceCount": { one: "{count} Gerät", other: "{count} Geräte" },
  "sites.cloud.alreadyAdded": "Hinzugefügt",
  "sites.cloud.addSites": { one: "{count} Standort hinzufügen", other: "{count} Standorte hinzufügen" },
  "sites.cloud.through": "Über {name} · {reach}",
  "sites.cloud.synced": "synchronisiert {when}",
  "sites.cloud.configure": "Konfigurieren",
  "sites.cloud.devicesOnline": "Geräte online",
  "sites.cloud.clients": "Clients",
  "sites.cloud.uplinksUp": "Uplinks aktiv",
  "sites.cloud.openAlerts": "Offene Warnungen",
  "sites.cloud.devices": "Geräte",
  "sites.cloud.noDevices": "Noch keine Geräte an diesem Standort.",
  "sites.cloud.type": "Typ",
  "sites.cloud.uptime": "Laufzeit",
  "sites.cloud.deviceType.ap": "Access Point",
  "sites.cloud.deviceType.switch": "Switch",
  "sites.cloud.deviceType.gateway": "Gateway",
  "sites.cloud.deviceType.other": "Sonstiges",
  "sites.cloud.updateAvailable": "Update verfügbar",
  "sites.cloud.restart": "Neu starten",
  "sites.cloud.restartSent": "Neustart gesendet",
  "sites.cloud.restartConfirm": "{name} neu starten? Seine Clients verlieren für etwa zwei Minuten die Verbindung.",
  "sites.cloud.upgrade": "Firmware aktualisieren",
  "sites.cloud.upgradeSent": "Firmware-Update gestartet",
  "sites.cloud.upgradeConfirm": "Firmware von {name} aktualisieren? Das Gerät startet neu und seine Clients verlieren für etwa zwei Minuten die Verbindung.",
  "sites.cloud.noClients": "Keine Clients verbunden.",
  "sites.cloud.connection": "Verbindung",
  "sites.cloud.blocked": "Gesperrt",
  "sites.cloud.wireless": "Drahtlos",
  "sites.cloud.wired": "Kabelgebunden",
  "sites.cloud.unblock": "Entsperren",
  "sites.cloud.unblocked": "Entsperrt",
  "sites.cloud.block": "Sperren",
  "sites.cloud.blockedDone": "Gesperrt",
  "sites.cloud.blockConfirm": "{name} sperren? Es kann sich erst wieder verbinden, wenn es entsperrt ist.",
  "sites.cloud.reconnect": "Neu verbinden",
  "sites.cloud.reconnectSent": "Neuverbindung gesendet",
  "sites.cloud.uplinks": "Uplinks",
  "sites.cloud.noUplinks": "Keine Uplinks gemeldet.",
  "sites.cloud.up": "Aktiv",
  "sites.cloud.down": "Ausgefallen",
  "sites.cloud.alerts": "Warnungen",
  "sites.cloud.events": "Neueste Ereignisse von {vendor}",
  "sites.cloud.eventsFailed": "Der Controller hat nicht geantwortet: {reason}",
  "sites.cloud.noEvents": "Keine neuen Ereignisse.",
  "sites.config.field.ssidOn": "SSID an",
  "sites.config.field.wifiKey": "WLAN-Schlüssel",
  "sites.config.help.wifiKey": "Nur schreiben: der aktuelle Schlüssel wird nie angezeigt",
  "sites.config.field.networkName": "Netzwerkname",
  "sites.config.field.siteName": "Standortname auf dem Controller",
  "sites.config.help.siteName": "Der eigene Name des Standorts im Dashboard bleibt, wie er ist",
  "sites.config.secretSet": "Gesetzt — einen neuen eingeben, um ihn zu ändern",
  "sites.cloud.lanAddressHint": "Seine eigene Adresse im Netzwerk vor Ort: die Weiterleitung geht dorthin, und das Netzwerk, in dem er ist, behält von hier aus sein VLAN.",
  "sites.cloud.controllerPort": "Eigener Port des Controllers",
  "sites.cloud.controllerPortHint": "8043 bei einem Software-Controller, 443 bei einem OC200 oder OC300",
  "sites.cloud.secretAgain": "Geben Sie das Client Secret erneut ein, wenn sich Adresse, Standort oder Port ändern: es wird nie von selbst an eine neue Adresse gesendet.",
  "sites.config.historySection.devices": "Geräte",
  "sites.config.historySection.clients": "Clients",
  "sites.removeSite": "Standort entfernen",
  "sites.removeConfirm": "Den Standort „{name}“ entfernen? Verlauf, Warnungen, Einstellungen und VPN-Verbindung werden mit entfernt. Das lässt sich nicht rückgängig machen.",
  "sites.config.help.radioOn": "Ein Funkmodul mit Verbindung auszuschalten trennt diese Verbindung",
  "sites.vpn.title": "VPN-Verbindung",
  "sites.vpn.connected": "Verbunden",
  "sites.vpn.waiting": "Wartet auf die VPN-Verbindung",
  "sites.vpn.notConnected": "Nicht verbunden",
  "sites.vpn.waitingPage": "Wartet auf die VPN-Verbindung: Die Angaben des Geräts erscheinen hier, sobald es sich verbindet",
  "sites.vpn.tunnelAddress": "Tunneladresse",
  "sites.vpn.lastSeen": "Zuletzt verbunden",
  "sites.vpn.never": "Nie",
  "sites.vpn.loadHint": "Laden Sie diese Datei als OpenVPN-Client auf den Router und lassen Sie HTTPS (Port 443) aus dem VPN auf dem Router zu (bei einem Teltonika: Netzwerk → Firewall → Traffic rules, von Zone openvpn zum Gerät, TCP 443, akzeptieren); der Standort ist hier online, sobald er sich verbindet",
  "sites.vpn.download": ".ovpn herunterladen",
  "sites.vpn.downloadFailed": "Download fehlgeschlagen",
  "sites.vpn.renew": "Zertifikat erneuern",
  "sites.vpn.renewed": "Neue VPN-Datei für den Standort erstellt",
  "sites.vpn.renewFailed": "Es konnte keine neue VPN-Datei erstellt werden",
  "sites.signIn.change": "Anmeldung ändern",
  "sites.signIn.title": "Die Anmeldung von {name} ändern",
  "sites.signIn.hint": "Ein leeres Feld behält das Gespeicherte. Passwörter und Tokens werden verschlüsselt gespeichert und nie angezeigt.",
  "sites.signIn.user": "Benutzername",
  "sites.signIn.password": "Passwort",
  "sites.signIn.token": "API-Token",
  "sites.signIn.apiKey": "API-Schlüssel",
  "sites.signIn.save": "Anmeldung speichern",
  "sites.signIn.saved": "Anmeldung gespeichert",
  "sites.signIn.savedText": "Das Gerät wird jetzt erneut damit abgefragt",
  "sites.signIn.failed": "Die Anmeldung konnte nicht gespeichert werden",
  "sites.direct.toggle": "VPN-Verbindung deaktivieren und eine direkte Adresse oder IP verwenden",
  "sites.add.vpnLine": "Über die VPN-Verbindung erreicht, unter der Tunneladresse des Gateways — wird von selbst gefunden",
  "sites.event.brand": "Veranstaltungen",
  "sites.event.badge": "Veranstaltung",
  "sites.event.archived": "Archiviert",
  "sites.archivedHint": "Standorte abgeschlossener Veranstaltungen: Sie bleiben hier für die Archivfrist in den Vermietungseinstellungen und werden dann entfernt.",
  "sites.event.rentalEvent": "Mietveranstaltung",
  "sites.event.period": "Mietzeitraum",
  "sites.event.material": "Material raus und zurück",
  "sites.event.devices": "Geräte",
  "sites.event.device": "Gerät",
  "sites.event.cameIn": "Kam in",
  "sites.event.state": "Status",
  "sites.event.uptime": "Laufzeit",
  "sites.event.clients": "Clients",
  "sites.event.traffic": "Verkehr",
  "sites.event.lastSeen": "Zuletzt gesehen",
  "sites.event.noDevices": "Kein Gerät des Geladenen ist gerade unterwegs",
  "sites.event.hidden": { one: "{count} Gerät ausgeblendet: Sie dürfen seinen Standort nicht sehen", other: "{count} Geräte ausgeblendet: Sie dürfen ihre Standorte nicht sehen" },
  "sites.event.alerts": "Meldungen",
  "sites.event.noAlerts": "Keine Meldungen",
  "sites.event.resolved": "gelöst",
  "sites.event.clientList": "Netzwerk-Clients",
  "sites.event.noClients": "Keine Clients",
  "sites.event.loads": "Was rausging",
  "sites.event.noLoads": "Noch nichts rausgegangen",
  "sites.event.wentOut": "Raus {when} · {who}",
  "sites.event.cameBack": "Zurück {when} · {who}: {status}",
  "sites.event.stillOut": "noch unterwegs",
  "sites.event.cameBackOf": "{back} von {out} zurück",
  "sites.event.graphs": "Diagramme",
  "sites.event.range": "Zeitraum",
  "sites.event.range24h": "24 Std.",
  "sites.event.range3d": "3 Tage",
  "sites.event.range1w": "1 Woche",
  "sites.event.rangeThisMonth": "Dieser Monat",
  "sites.event.rangeLastMonth": "Letzter Monat",
  "sites.event.rangeCustom": "Benutzerdefiniert",
  "sites.event.from": "Von",
  "sites.event.to": "Bis",
  "sites.event.rangeInvalid": "Das Ende liegt vor dem Beginn",
  "sites.event.totalInRange": "In diesem Zeitraum: ↓ {rx} · ↑ {tx}",
  "sites.event.graphTraffic": "Gesamter Datenverkehr",
  "sites.event.graphDevices": "Geräte online und offline",
  "sites.event.noSamples": "In diesem Zeitraum nichts aufgezeichnet: Die Diagramme füllen sich, solange das Material draußen ist",
  "sites.event.asTable": "Als Tabelle anzeigen",
  "sites.event.time": "Zeit",
  "sites.cloud.username": "Benutzername",
  "sites.cloud.password": "Passwort",
  "sites.cloud.registerTitleSz": "Ruckus-Standorte hinzufügen",
  "sites.cloud.registerSubtitleSz": "Die Zonen eines Ruckus-SmartZone-Controllers, erreicht über das VPN eines Standorts oder unter einer Adresse",
  "sites.cloud.credentialsSz": "Anmeldedaten von SmartZone",
  "sites.cloud.credentialsWhereSz": "Ein SmartZone-Administrator mit einer Rolle mit Lese- und Schreibrechten ({menu})",
  "sites.cloud.secretAgainSz": "Geben Sie das Passwort erneut ein, wenn sich die Adresse, der Standort oder der Port ändert: Es wird nie von selbst an eine neue Adresse gesendet.",
  "sites.cloud.controllerPortHintSz": "8443 bei SmartZone",
  "sites.cloud.siteFirmware": "AP-Firmware aktualisieren",
  "sites.cloud.siteFirmwareCurrent": "Aktuelle Version",
  "sites.cloud.siteFirmwareNew": "Neue Version",
  "sites.cloud.siteFirmwareNone": "Keine neuere Version auf dem Controller",
  "sites.cloud.siteFirmwareUpdate": "Aktualisieren",
  "sites.cloud.siteFirmwareConfirm": "Jeder Access Point dieses Standorts startet neu, um auf {version} zu wechseln. Fortfahren?",
  "sites.cloud.siteFirmwareSent": "Firmware-Update gestartet",
  "sites.config.wifiOnly": "Die Standorte dieses Controllers haben nur WLAN-Einstellungen: VLANs werden pro WLAN festgelegt.",
  "sites.event.comment": "Kommentar",
  "sites.event.commentOf": "Kommentar zu {name}",
  "sites.event.commentPlaceholder": "Kommentar hinzufügen",
  "sites.event.commentSaved": "Kommentar gespeichert",
  "sites.event.commentFailed": "Der Kommentar wurde nicht gespeichert",
  "sites.event.commentBy": "{name}, {when}",
  "sites.add.choose": "Was fügen Sie hinzu?",
  "sites.speedTest": "Geschwindigkeitstest ↓ {down} ↑ {up}",
  "sites.speedTestAt": "Der letzte Geschwindigkeitstest des Gateways, {when}: was die Leitung schafft",
  "sites.dataUsed": "Datenverbrauch ({period}): ↓ {rx} ↑ {tx}",
}

export default sites
